import React from "react";
import AiVideoWizard from "./AiVideoWizard";

const AiVideo = () => {
  return (
    <div style={{ width: "100%", height: "100%", padding: 16 }}>
      <AiVideoWizard />
    </div>
  );
};

export default AiVideo;
